import React from 'react';

import FlyingPlane from '../../assets/svg-components/flying_plane.svg';
import { Label } from '../label/label';
import { SocialMedia } from '../social-media-buttons/social-media';
import { Text } from '../text/text';
import { Title } from '../title/title';
import { Translate } from '../translate';
import './giveaway-card.scss';

const GiveawayCard = () => {
  return (
    <div className="bd-giveaway">
      <img
        className="bd-giveaway__img"
        src="https://www.siteground.com/static/2024/en/img/web/sg_birthday/illustration_tshirt.png"
        alt="Giveaway T-Shirt Image"
      />
      <div className="bd-giveaway__text">
        <Title level="3" weight="bold" align="center">
          <Translate id="translate.giveaway.card.title" />
        </Title>
        <div className="bd-giveaway__title">
          <Text size="large">
            <Translate id="translate.giveaway.card.subtitle" />
          </Text>{' '}
          <Label color="#98E5B9">
            <Text size="large">
              <Translate id="translate.giveaway.card.hashtag" />
            </Text>
          </Label>
        </div>
        <SocialMedia intlType="giveaway" />
      </div>
      <div className="bd-giveaway__flying-plane">
        <FlyingPlane className="bd-giveaway__flying-plane__icon" />
      </div>
    </div>
  );
};

export default GiveawayCard;
